
import { defineComponent, ref } from "vue-demi";

export default defineComponent({
  name: "SLPopup",

  emits: ["ok", "cancel"],

  setup(_, { emit }) {
    const isPopoverOpen = ref(true);

    const onOk = () => {
      emit("ok");
    };

    const onCancel = () => {
      isPopoverOpen.value = false;

      emit("cancel");
    };

    return {
      isPopoverOpen,
      onOk,
      onCancel,
    };
  },
});
